import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Params } from "@angular/router";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from "@angular/forms";

import { CrudService } from "../../../crud/crud.service";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import "jspdf-autotable";
import * as $ from "jquery";
import { Mensaje } from "../../../mensaje";
import { NotificationsService } from 'angular2-notifications';
import { isUndefined } from "util";

import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-horario-diario",
  templateUrl: "./horario-diario.component.html"
})
export class HorarioDiarioComponent implements OnInit{
  @ViewChild("periodoAnterior") periodoAnterior: ElementRef;
  @ViewChild("modalidad") modalidad: ElementRef;
  @ViewChild("tipoPeriodo") tipoPeriodo: ElementRef;

  dato: FormGroup;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  API_PATH = environment.API_PATH;

  dia_semana;
  horario_diario = [];
  ph_modulos = [];
  ph_horas = [];
  ph_modalidades = [];

  dia_sel;
  periodo_sel;
  cargando = false;
  horario_cargado = false;

  logo_sucursal = "";
  logo_empresa = "";
  activos = true;

  mensajeResponse: Mensaje = new Mensaje(true);
  //mostrar notificaciones
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  dias_disponibles = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private crud: CrudService,
    private notificacion: NotificationsService
  ) {}

  ngOnInit() {
    this.dato = this.fb.group({
      id: [""]
    });
    document.getElementById("catalogos").click();
  }
  seleccionarPeriodo(event, peridos) {
    if(event){
      if (event.hasOwnProperty("value")) {
        this.periodo_sel =  event.value;
      }else{
        this.periodo_sel = event;
      }
    }
    peridos.forEach(element => {
      if (element.id == this.periodo_sel) {
        this.dias_disponibles = [];
        element.modalidades.modalidades_dias.forEach(ele => {
          this.dias_disponibles.push({
            id: ele.dias_semanas_id,
            text: ele.dias_semanas.nombre
          });
        });
      }
    });
    if ((this.periodo_sel || this.activos) && this.dia_sel)
      this.horarioDiario();
  }
  seleccionarDia(event) {
    if(event){
      if (event.hasOwnProperty("value")) {
        this.dia_sel =  event.value;
      }else{
        this.dia_sel = event;
      }
    }

    this.dias_disponibles.forEach(element => {
      if (element.id == this.dia_sel) {
        this.dia_semana = element;
      }
    });

    if ((this.periodo_sel || this.activos) && this.dia_sel)
      this.horarioDiario();
  }
  seleccionarActivos(event, dia_semana) {
    if ((this.periodo_sel || this.activos) && this.dia_sel)
      this.horarioDiario();
    if (this.activos) {
      this.dias_disponibles = dia_semana;
    }
  }
  parametros = {
    pagina: 0,
    limite: 0
  };
  horarioDiario() {
    this.cargando = true;
    this.horario_cargado = false;
    try {
      this.horario_diario = [];
      this.crud
        .lista(
          this.parametros,
          "horario-diario" +
            "?periodos_escolares_id=" +
            this.periodo_sel +
            "&dias_semanas_id=" +
            this.dia_sel +
            "&activos=" +
            this.activos
        )
        .subscribe(
          resultado => {
            this.cargando = false;
            if (resultado.status == 200) {
              let ph_horas = [];
              let ph_modulos = [];
              let ph_modalidades = [];
              this.horario_diario = [];
              resultado.data.forEach(element => {
                  let elmodulo =  element.fecha_inicio + " al " + element.fecha_fin;
                  let elhora   =  element.hora_inicio + " a " + element.hora_termino;
                  let modalidad = element.modalidades.nombre;

                  ph_modalidades.push(modalidad);

                  if (typeof ph_horas[modalidad] == "undefined")
                    ph_horas[modalidad] = [];

                  if (typeof ph_modulos[modalidad] == "undefined")
                    ph_modulos[modalidad] = [];

                  if (typeof this.horario_diario[modalidad] == "undefined")
                    this.horario_diario[modalidad] = [];

                  if (typeof this.horario_diario[modalidad][elmodulo] == "undefined")
                    this.horario_diario[modalidad][elmodulo] = [];

                  if (typeof this.horario_diario[modalidad][elmodulo][elhora] == "undefined")
                    this.horario_diario[modalidad][elmodulo][elhora] = [];

                  ph_modulos[modalidad].push(elmodulo);
                  ph_horas[modalidad].push(elhora);

                  this.horario_diario[modalidad][elmodulo][elhora].push(element);
                }
              );

              this.ph_modalidades = this.arrayUnico(ph_modalidades);

              this.ph_modalidades.forEach(modalidad => {
                this.ph_horas[modalidad] = this.arrayUnico(ph_horas[modalidad]).sort();
                this.ph_modulos[modalidad] = this.arrayUnico(ph_modulos[modalidad]);
              });
              this.horario_cargado = true;
            }
          },
          error => {
            this.cargando = false;
          }
        );
    } catch (e) {
      console.log(e);
    }
  }

  arrayUnico(array) {
    return array.filter(function(valor, indiceActual, arreglo) {
      let indiceAlBuscar = arreglo.indexOf(valor);
      if (indiceActual === indiceAlBuscar) {
        return true;
      } else {
        return false;
      }
    });
  }


  generarPDF() {
    try{
      let html = document.getElementById("contenido_horario").innerHTML;

      html =
        '<html lang="es">' +
        " <head>" +
        ' <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />' +
        ' <meta name="charset" content="UTF-8">' +
        ' <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">' +
        ' <meta name="apple-mobile-web-app-capable" content="yes">' +
        ' <title>PDF</title> <meta name="viewport" content="initial-scale=1" />' +
        ' <link rel="stylesheet" href="https://bulma.io/css/bulma-docs.css?v=201712202318">' +
        " <style>html { font-size: .8em; font-weight: 900; color: #000000;} body {font-size: .8em; font-weight: 900; color: #000000;} select::-ms-expand {display: none;} table{font-size: .7em}" +
        ".figure-border { border-radius: 5px; box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);" +
        " min-height: 159px;} .hr{ margin: .85rem 0 !important;} .sellos_sat{ font-size:8.5pt !important;}" +
        ".columns{margin:0px !important} .column{padding: .2em !important}</style>" +
        " </head>" +
        " <body>" +
        html +
        " </body>" +
        " </html>";
        
      let iframe = document.createElement("iframe");
      iframe.setAttribute("id", "printf");
      
      document.body.appendChild(iframe);

      const mywindow: HTMLIFrameElement = document.getElementById('printf') as HTMLIFrameElement;
      mywindow.contentWindow.document.write(html);
      setTimeout(() => {
        //  lanzar la sentencia imprimir
        mywindow.contentWindow.print();
      }, 500);
      setTimeout(() => {
        //  remover el contenedor de impresión
        document.body.removeChild(iframe);
      }, 2000);
    }catch(e){
      console.log(e);
    }
  }

  asignarLogos(logos) {
    this.logo_sucursal = logos.sucursal;
    this.logo_empresa = logos.empresa;
  }
  asignarDiaSemana(dias){
    this.dias_disponibles = dias;
  };

}
